import { Component, HostBinding, OnInit } from '@angular/core';
import { PanelType } from '../../models/panel-type';
import { PanelComponent } from '../panel.component';

@PanelComponent.register
@Component({
  selector: 'app-header-panel',
  templateUrl: './header-panel.component.html',
  styleUrls: ['./header-panel.component.scss'],
  imports: [],
})
export class HeaderPanelComponent extends PanelComponent implements OnInit {
  public static override readonly type = PanelType.Header;
  @HostBinding('class') public class = 'col-12 mt-3 sticky-top bg-background';
  @HostBinding('id') public id: string | undefined;

  ngOnInit(): void {
    this.id = this.title;
  }
}
